import { TeamData, FileUrl } from "../../../hooks/useApiCalls";
import TeamCard from "./components/TeamCard";



function Team() {

   const teamdata = TeamData();
 
    return ( 
       <>
        <section id="team" className="py-5">
        <div className="container">
          <h2 className="text-center text-white mb-5">Team</h2>
          <div className="row justify-content-center">

              {Array.isArray(teamdata) && teamdata.map((data)=>{
                  return <TeamCard image={FileUrl(data.image)} namelastname = {data.namelastname} job={data.role} social={data.social_media} />
              })}

          </div>
        </div>
      </section>
      
    </> 
 ); 

}

export default Team;